import React, { useEffect, useContext, useState } from "react";
import axios from "axios";
import { GlobalState } from "../Helper/Context";
import LoadingSurah from "./LoadingSurah";
import SurahItem from "./SurahItem";
const Surah = () => {
  const [allSurah, setAllSurah] = useState([]);
  const [loading, setLoading] = useState(true);
  const { state, setState } = useContext(GlobalState);
  const loopLoading = Array(48).fill(0);
  useEffect(() => {
    axios
      .get("https://api.alquran.cloud/v1/surah")
      .then((res) => setAllSurah(res.data.data))
      .then(() => setLoading(false));
  }, []);
  return (
    <ul
      className={`flex flex-wrap gap-4 px-8 ${
        state.langTo === "EN" && "notranslate"
      }`}
    >
      {loading
        ? loopLoading.map((e, i) => (
            <LoadingSurah
              key={i}
              width={state.listMode === "grid" ? "w-1/6" : "w-full"}
            />
          ))
        : allSurah.map((surah) =>
            state.search === "" ? (
              <SurahItem
                key={surah.number}
                onclick={() => {
                  localStorage.setItem("selectedSurah", JSON.stringify(surah));
                  setState({
                    ...state,
                    selectedSurah: JSON.parse(localStorage.selectedSurah),
                  });
                }}
                onclicklike={() => {
                  state.favSurah.includes(JSON.stringify(surah))
                    ? localStorage.setItem(
                        "favSurah",
                        JSON.stringify(
                          JSON.parse(`[${localStorage.favSurah}]`).filter(
                            (item) => item.number !== surah.number
                          )
                        )
                          .replace("[", "")
                          .replace("]", "")
                      )
                    : localStorage.favSurah
                    ? (localStorage.favSurah += `,${JSON.stringify(surah)}`)
                    : localStorage.setItem("favSurah", JSON.stringify(surah));
                  setState({ ...state, favSurah: localStorage.favSurah });
                }}
                number={surah.number}
                name={surah.name}
                eName={surah.englishName}
                type={surah.revelationType}
                ayahNum={surah.numberOfAyahs}
                langTo={state.langTo}
                selected={surah.number === state.selectedSurah.number}
                listMode={state.listMode}
                fill={
                  state.favSurah.includes(surah.name) ? "#00ad67" : "#ffffff"
                }
              />
            ) : (
              (surah.name
                .replace(/[\u064B-\u065F|\u06E1]/g, "")
                .replaceAll("ٱ", "ا")
                .replaceAll("ىٰ", "ى")
                .replaceAll("مٰ", "م")
                .includes(state.search) ||
                surah.englishName
                  .toLocaleLowerCase()
                  .includes(state.search.toLocaleLowerCase())) && (
                <SurahItem
                  key={surah.number}
                  onclick={() => {
                    localStorage.setItem(
                      "selectedSurah",
                      JSON.stringify(surah)
                    );
                    setState({
                      ...state,
                      selectedSurah: JSON.parse(localStorage.selectedSurah),
                    });
                  }}
                  onclicklike={() => {
                    state.favSurah.includes(JSON.stringify(surah))
                      ? localStorage.setItem(
                          "favSurah",
                          JSON.stringify(
                            JSON.parse(`[${localStorage.favSurah}]`).filter(
                              (item) => item.number !== surah.number
                            )
                          )
                            .replace("[", "")
                            .replace("]", "")
                        )
                      : localStorage.favSurah
                      ? (localStorage.favSurah += `,${JSON.stringify(surah)}`)
                      : localStorage.setItem("favSurah", JSON.stringify(surah));
                    setState({ ...state, favSurah: localStorage.favSurah });
                  }}
                  number={surah.number}
                  name={surah.name}
                  eName={surah.englishName}
                  type={surah.revelationType}
                  ayahNum={surah.numberOfAyahs}
                  langTo={state.langTo}
                  selected={surah.number === state.selectedSurah.number}
                  listMode={state.listMode}
                  fill={
                    state.favSurah.includes(surah.name) ? "#00ad67" : "#ffffff"
                  }
                />
              )
            )
          )}
    </ul>
  );
};

export default Surah;
